import { createAsyncThunk } from '@reduxjs/toolkit';

import * as api from 'api/methods';

import * as types from './types';

export const getReviews = createAsyncThunk<any, any>(
  types.GET_REVIEWS,
  async (params: Record<string, any>) => {
    const reviews = await api.getStudentReviews(params);

    return reviews;
  },
);

export const getReviewsByStudentId = createAsyncThunk<any, any>(
  types.GET_REVIEWS_BY_STUDENT_ID,
  async ({
    studentId,
    ...params
  }: {
    studentId: string;
    params: Record<string, any>;
  }) => {
    const reviews = await api.getStudentReviewsByStudentId({
      studentId,
      params,
    });

    return reviews;
  },
);
